import MeetingDetailsController from './MeetingDetailsController'

export default MeetingDetailsController
